<template>
  <div>
    <div class="flex m-b-30">
      <i class="icon las bg-white-60 color-blue-1" :class="['la-' + content.item.ball_icon]"></i>
      <div>
        <h2 class="font-size-l color-blue-1 m-tb-0">{{ content.item.ball_label }}</h2>
        <h3 class="font-size-n color-blue-1 m-tb-0">{{ content.section }}</h3>
      </div>
    </div>
    <h1 class="font-size-xl color-blue-1 m-t-0 m-b-15">{{ content.item.content_label }}</h1>
    <div class="bg-white-60" v-html="content.item.content_column_1"></div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      default: {
        item: {},
        section: '',
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  .icon
  {
    font-size: 50px;
    flex: 0 0 60px;
    max-width: 60px;
    // background-color: white;
  }
</style>